import { ButtonBase } from '@mui/material'
import type { FC } from 'react'
import BaseLikeButton from 'src/components/LikeButton/BaseLikeButton'
import { LikeHeart } from 'src/components/LikeButton/LikeHeart'
import type { Manga } from 'src/services/apollo/generated/graphql'
import {
  MangaType,
  MarkType,
  RefType,
} from 'src/services/apollo/generated/graphql'
import { executeMarkManga } from 'src/services/apollo/manga'
import { isAnimatedComic } from 'src/utils/artwork'
import { cx } from 'src/utils/cx'
import { formatNum } from 'src/utils/formatNum'
import { track } from 'src/utils/tracker'

const MangaLikeButton: FC<
  StyleProps & {
    id?: string
    manga?: Manga
    initialValue?: boolean
    initialCount?: number
    afterClick?: () => void
  }
> = ({
  manga,
  id = manga?.id,
  initialCount = manga?.likedCount,
  initialValue = manga?.liked,
  className,
  style,
  afterClick,
}) => {
  if (!id) return null
  return (
    <BaseLikeButton
      id={id}
      initialCount={initialCount}
      initialValue={initialValue}
      onSuccess={target => {
        if (target) {
          track(
            'like_click',
            {
              id: manga?.artworkId,
              type: isAnimatedComic(manga)
                ? MangaType.AnimatedComic
                : RefType.Manga,
            },
            // Skip getway
            { destinations: ['amplitude'] },
          )
          afterClick?.()
        }
      }}
      handler={async (id, target) => {
        await executeMarkManga({
          mangaId: id,
          type: MarkType.Like,
          target,
        })
      }}
      render={({ value, count, onClick }) => (
        <ButtonBase
          component="div"
          role="button"
          className={cx(
            'cursor-pointer outline transition -m-2 p-2 rounded-md focus-within:outline-1',
            className,
          )}
          style={style}
          onClick={onClick}
        >
          <div className="flex gap-1 items-center">
            <LikeHeart liked={value} className="size-5" />
            {!count ? null : (
              <span
                className="text-sm tabular-nums"
                style={{
                  color: 'inherit',
                }}
              >
                {formatNum(count || 0)}
              </span>
            )}
          </div>
        </ButtonBase>
      )}
    />
  )
}

export default MangaLikeButton
